var _path, _path2, _g, _path3, _g2, _defs;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var s = Object.getOwnPropertySymbols(e); for (r = 0; r < s.length; r++) o = s[r], t.includes(o) || {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (e.includes(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgIconTendoo(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 28,
    height: 28,
    viewBox: "0 0 28 28",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip0_6057_39834)"
  }, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M28 14.0039C28 6.27192 21.732 0.00390625 14 0.00390625C6.26801 0.00390625 0 6.27192 0 14.0039C0 21.7359 6.26801 28.0039 14 28.0039C21.732 28.0039 28 21.7359 28 14.0039Z",
    fill: "url(#paint0_linear_6057_39834)"
  })), /*#__PURE__*/React.createElement("mask", {
    id: "mask0_6057_39834",
    style: {
      maskType: "luminance"
    },
    maskUnits: "userSpaceOnUse",
    x: 0,
    y: 0,
    width: 28,
    height: 28
  }, _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M28 14C28 6.26801 21.732 0 14 0C6.26801 0 0 6.26801 0 14C0 21.732 6.26801 28 14 28C21.732 28 28 21.732 28 14Z",
    fill: "white"
  }))), _g || (_g = /*#__PURE__*/React.createElement("g", {
    mask: "url(#mask0_6057_39834)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M24.5556 24.3574H4.40771V30.4367H24.5556V24.3574Z",
    fill: "url(#paint1_linear_6057_39834)"
  }))), /*#__PURE__*/React.createElement("mask", {
    id: "mask1_6057_39834",
    style: {
      maskType: "luminance"
    },
    maskUnits: "userSpaceOnUse",
    x: 0,
    y: 0,
    width: 28,
    height: 28
  }, _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M28 14C28 6.26801 21.732 0 14 0C6.26801 0 0 6.26801 0 14C0 21.732 6.26801 28 14 28C21.732 28 28 21.732 28 14Z",
    fill: "white"
  }))), _g2 || (_g2 = /*#__PURE__*/React.createElement("g", {
    mask: "url(#mask1_6057_39834)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M14.4585 4.08236C14.1547 3.99089 13.8509 3.99089 13.5471 4.08166C13.5084 5.25113 13.5124 6.34149 12.9673 7.13133C13.657 7.60149 14.3465 7.60149 15.036 7.13133C14.4917 6.34103 14.4956 5.25113 14.4585 4.08236Z",
    fill: "url(#paint2_linear_6057_39834)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M14.0011 5.02864C14.6892 5.02864 15.2469 4.47089 15.2469 3.78288C15.2469 3.09486 14.6892 2.53711 14.0011 2.53711C13.3131 2.53711 12.7554 3.09486 12.7554 3.78288C12.7554 4.47089 13.3131 5.02864 14.0011 5.02864Z",
    fill: "url(#paint3_linear_6057_39834)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M24.6234 19.3126L22.2378 13.4434L25.8192 14.0533C26.2784 14.1424 26.628 14.4374 26.711 14.8058L27.3023 17.4266C27.4306 17.995 27.0522 18.5594 26.3858 18.7939L24.759 19.3665C24.7025 19.3864 24.6369 19.3605 24.6234 19.3126Z",
    fill: "#21201E"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M3.38342 19.3126L5.76902 13.4434L2.18759 14.0533C1.72839 14.1424 1.37886 14.4374 1.29579 14.8058L0.704524 17.4266C0.57619 17.995 0.954657 18.5594 1.62106 18.7939L3.24786 19.3665C3.30432 19.3864 3.36989 19.3605 3.38342 19.3126Z",
    fill: "#21201E"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M25.6441 19.8118C25.6441 19.8463 25.6441 19.8841 25.6411 19.9186C25.6264 20.6984 25.4481 21.4516 25.1284 22.1624C24.1727 24.2878 22.0636 25.5826 19.8182 25.5826H8.18378C5.92348 25.5826 3.80341 24.2696 2.85468 22.1234C2.53548 21.4012 2.36211 20.6359 2.35791 19.8433V19.8118C2.35791 19.5222 2.38194 19.2392 2.42418 18.9589L2.63161 16.9765C3.23618 11.1647 7.87414 6.76562 13.3964 6.76562H14.6025C20.1248 6.76562 24.7658 11.1647 25.3674 16.9765L25.5718 18.9274C25.6198 19.217 25.6439 19.5126 25.6439 19.8118H25.6441Z",
    fill: "url(#paint4_linear_6057_39834)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M14.0012 24.465C10.2875 24.465 6.994 23.6575 5.3924 22.3552C4.38183 21.6676 3.87737 20.5231 4.075 19.3602L4.7953 15.1219C5.0501 13.623 6.39713 12.5352 7.99873 12.5352C8.4283 12.5352 8.84994 12.6154 9.25197 12.7736C10.1916 13.1437 11.2306 13.3915 12.3399 13.51C12.8192 13.5621 13.2942 13.5887 13.7532 13.5887C13.8339 13.5887 13.9128 13.5877 13.9891 13.5861C14.0932 13.588 14.172 13.5887 14.2525 13.5887C14.7094 13.5887 15.1833 13.5621 15.6614 13.51C16.7721 13.3915 17.8106 13.1437 18.7505 12.7736C19.1525 12.6154 19.5739 12.5352 20.0033 12.5352C21.6046 12.5352 22.9521 13.623 23.2072 15.1217L23.9275 19.3606C24.1246 20.5233 23.6202 21.6681 22.6098 22.3555C21.0082 23.6577 17.7147 24.4653 14.001 24.4653L14.0012 24.465Z",
    fill: "url(#paint5_linear_6057_39834)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M23.3079 19.8201L22.5876 15.3581C22.3177 13.6865 20.5576 12.7188 18.9934 13.3673C17.8678 13.8339 16.7382 14.0736 15.7349 14.1863C15.0962 14.2593 14.5085 14.2812 14.0047 14.2703C13.5012 14.2812 12.9097 14.2593 12.271 14.1863C11.2677 14.0736 10.1381 13.8337 9.01253 13.3673C7.44827 12.7188 5.68823 13.6865 5.41827 15.3581L4.69797 19.8201C4.5309 20.8549 4.99523 21.8244 5.7825 22.3767C7.2 23.6078 10.3463 24.4646 14.0031 24.4646C17.6599 24.4646 20.8059 23.6078 22.2234 22.3767C23.0107 21.8244 23.475 20.8552 23.3079 19.8201Z",
    fill: "url(#paint6_linear_6057_39834)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M8.32675 21.2887C9.12044 21.2887 9.76385 20.5529 9.76385 19.6453C9.76385 18.7377 9.12044 18.002 8.32675 18.002C7.53306 18.002 6.88965 18.7377 6.88965 19.6453C6.88965 20.5529 7.53306 21.2887 8.32675 21.2887Z",
    fill: "url(#paint7_linear_6057_39834)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M19.6768 21.2887C20.4705 21.2887 21.1139 20.5529 21.1139 19.6453C21.1139 18.7377 20.4705 18.002 19.6768 18.002C18.8832 18.002 18.2397 18.7377 18.2397 19.6453C18.2397 20.5529 18.8832 21.2887 19.6768 21.2887Z",
    fill: "url(#paint8_linear_6057_39834)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M15.4125 20.6484C15.622 20.6484 15.7676 20.861 15.6897 21.0556C15.5973 21.2866 15.4552 21.4947 15.2732 21.6721C14.9519 22.0008 14.5037 22.2024 14.0029 22.2024C13.5022 22.2024 13.0467 22.0006 12.7254 21.6721C12.5486 21.495 12.4053 21.2875 12.3115 21.0572C12.2322 20.8624 12.3778 20.6484 12.5882 20.6484H15.4127H15.4125Z",
    fill: "url(#paint9_linear_6057_39834)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M15.2748 21.6686C14.9535 21.9974 14.5053 22.199 14.0046 22.199C13.5038 22.199 13.0484 21.9971 12.7271 21.6686C13.0185 21.3921 13.4817 21.2129 13.9973 21.2129C14.513 21.2129 14.9759 21.3921 15.2748 21.6686Z",
    fill: "url(#paint10_linear_6057_39834)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M11.1201 16.6348H11.0585C10.5424 16.6348 10.124 17.0532 10.124 17.5693V19.0442C10.124 19.5603 10.5424 19.9787 11.0585 19.9787H11.1201C11.6362 19.9787 12.0546 19.5603 12.0546 19.0442V17.5693C12.0546 17.0532 11.6362 16.6348 11.1201 16.6348Z",
    fill: "#21201E"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M16.9419 16.6348H16.8803C16.3642 16.6348 15.9458 17.0532 15.9458 17.5693V19.0442C15.9458 19.5603 16.3642 19.9787 16.8803 19.9787H16.9419C17.458 19.9787 17.8764 19.5603 17.8764 19.0442V17.5693C17.8764 17.0532 17.458 16.6348 16.9419 16.6348Z",
    fill: "#21201E"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M16.6196 22.6895H15.8879C15.3371 22.6895 14.8906 23.1359 14.8906 23.6866C14.8906 24.2373 15.3371 24.6838 15.8879 24.6838H16.6196C17.1704 24.6838 17.6169 24.2373 17.6169 23.6866C17.6169 23.1359 17.1704 22.6895 16.6196 22.6895Z",
    fill: "#21201E"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M16.8208 23.8068C16.8208 23.8068 24.7663 24.8134 26.139 17.7949",
    stroke: "#21201E",
    strokeWidth: 0.6293,
    strokeMiterlimit: 10,
    strokeLinecap: "round"
  })))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint0_linear_6057_39834",
    x1: 14,
    y1: 24.4988,
    x2: 14,
    y2: -5.16396,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0.64,
    stopColor: "#FBEAEA"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.73,
    stopColor: "#F7D6D7"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.85,
    stopColor: "#F2B8BA"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint1_linear_6057_39834",
    x1: 14.5295,
    y1: 21.5049,
    x2: 14.4833,
    y2: 27.1938,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0.14,
    stopColor: "#D9373C"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.36,
    stopColor: "#DA4045"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.37,
    stopColor: "#E26468"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.38,
    stopColor: "#E78184"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.4,
    stopColor: "#EB9598"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.41,
    stopColor: "#EEA1A4"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.42,
    stopColor: "#EFA6A9"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.44,
    stopColor: "#E89598"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.47,
    stopColor: "#DD757A"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.51,
    stopColor: "#D45A60"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.55,
    stopColor: "#CC444B"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.6,
    stopColor: "#C6333A"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.66,
    stopColor: "#C2272F"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.75,
    stopColor: "#BF2028"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.98,
    stopColor: "#BF1F27"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint2_linear_6057_39834",
    x1: 14.0239,
    y1: 4.04325,
    x2: 13.9273,
    y2: 7.22232,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#F9AFB4"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.576923,
    stopColor: "#FFD2D5"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.913729,
    stopColor: "#F28C93"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint3_linear_6057_39834",
    x1: 14.028,
    y1: 2.55834,
    x2: 13.961,
    y2: 5.62014,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#FFAEB3"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.416941,
    stopColor: "#FFD2D5"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.913729,
    stopColor: "#F28C93"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint4_linear_6057_39834",
    x1: 14.001,
    y1: 7.15039,
    x2: 14.001,
    y2: 23.5542,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0.14,
    stopColor: "#D9373C"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.42,
    stopColor: "#EFA6A9"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.44,
    stopColor: "#ED9C9F"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.51,
    stopColor: "#E5787C"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.58,
    stopColor: "#E05B60"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.65,
    stopColor: "#DC474C"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.72,
    stopColor: "#D93B40"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.79,
    stopColor: "#D9373C"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.83,
    stopColor: "#CF2E34"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.91,
    stopColor: "#C3222A"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.98,
    stopColor: "#BF1F27"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint5_linear_6057_39834",
    x1: 13.8638,
    y1: 12.4257,
    x2: 14.0869,
    y2: 24.4678,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0.24,
    stopColor: "#FBEAEA"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.39,
    stopColor: "#F7D5D6"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.56,
    stopColor: "#F4C5C6"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.76,
    stopColor: "#F2BBBD"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#F2B8BA"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint6_linear_6057_39834",
    x1: 13.8701,
    y1: 13.0548,
    x2: 14.0812,
    y2: 24.4672,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#FBEAEA"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.03,
    stopColor: "#FCF1F1"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.09,
    stopColor: "#FEFBFB"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.17,
    stopColor: "white"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.36,
    stopColor: "#FEFAFA"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.56,
    stopColor: "#FBEEEF"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.76,
    stopColor: "#F8DADB"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.97,
    stopColor: "#F3BDBF"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#F2B8BA"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint7_linear_6057_39834",
    x1: 8.32675,
    y1: 17.8412,
    x2: 8.32675,
    y2: 21.845,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#FFC8D7"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.46,
    stopColor: "#FAB5B7"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#F5A398"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint8_linear_6057_39834",
    x1: 19.6768,
    y1: 17.8412,
    x2: 19.6768,
    y2: 21.845,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#FFC8D7"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.46,
    stopColor: "#FAB5B7"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#F5A398"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint9_linear_6057_39834",
    x1: 12.2893,
    y1: 21.4254,
    x2: 15.7109,
    y2: 21.4254,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0.41,
    stopColor: "#D5544C"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.46,
    stopColor: "#DB5C53"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.61,
    stopColor: "#E96D64"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.76,
    stopColor: "#F2776D"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.95,
    stopColor: "#F57B71"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint10_linear_6057_39834",
    x1: 14.013,
    y1: 21.1882,
    x2: 13.9948,
    y2: 21.9171,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0.45,
    stopColor: "#F99C9C"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.54,
    stopColor: "#F79390"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.83,
    stopColor: "#F57B71"
  })), /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0_6057_39834"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 28,
    height: 28.0039,
    fill: "white"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgIconTendoo);
export default __webpack_public_path__ + "static/media/icon-tendoo.44356d2fcec2ebf6446cf990d81a1ca4.svg";
export { ForwardRef as ReactComponent };